import { Link } from '@customink/pigment-react';

import { CustomerCareNumber } from '@/constants';

export function CustomerCareLink() {
  return (
    <>
      {' '}
      <Link
        href={`tel:${CustomerCareNumber}`}
        style={{ textDecoration: 'none' }}
      >
        {CustomerCareNumber}
      </Link>{' '}
    </>
  );
}
